import * as React from "react";
import { useAsyncAbortable } from "react-async-hook";
import useConstant from "use-constant";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { ISortOrder, Condition, FileType, } from "@warda/library-ui/interfaces";
import { AttributeFamily, SearchMode } from "../../../interfaces";
import { SEARCH_FILES_RESULT_DEFAULT, getFiles, } from "../../../api/fetchesApiMediaLibrary";
import { composePath, getQueryParams, updateSearchString, } from "../searchString";
import { AREA } from "../constants";
import { areFiltersUseful } from "../../PanelFilters";
import { getQuery } from "../../AreaProducts/useSearchEs";
export const getIdForSearchAfter = (fileType) => {
    switch (fileType) {
        case FileType.PORTAL:
            return "hierarchyId";
        case FileType.FOLDER:
            return "folderId";
        case FileType.MEDIA:
            return "fileId";
    }
};
const getSize = (type) => {
    switch (type) {
        case FileType.PORTAL:
        case FileType.FOLDER:
            return 50;
        case FileType.MEDIA:
            return 1000;
        default:
            return 10;
    }
};
const composeQuery = ({ area, filters, filtersCondition, }) => {
    if (area === AREA.PORTALS_LIST)
        return undefined;
    return getQuery({
        filters,
        filtersCondition,
    });
};
export const searchFiles = async ({ permissions, sortKey, sortOrd, filters, filtersCondition, filtersScope, type, searchAfter, area, hrch, prnt, }) => {
    const isFiltered = areFiltersUseful(filters);
    const searchMode = isFiltered ? SearchMode.HIERARCHY : SearchMode.DEFAULT;
    const createSearchEs = (fileType) => {
        const metaFilters = filters.filter((f) => f.attributeFamily === AttributeFamily.METADATA);
        const otherFilters = filters.filter((f) => f.attributeFamily !== AttributeFamily.METADATA);
        const isExcludedType = !(!type || type === fileType) ||
            (fileType !== FileType.MEDIA &&
                areFiltersUseful(metaFilters) &&
                (filtersCondition === Condition.AND ||
                    !areFiltersUseful(otherFilters)));
        const aFilters = fileType !== FileType.MEDIA ? otherFilters : filters;
        return {
            search_after: isExcludedType ? undefined : searchAfter,
            size: isExcludedType ? 0 : getSize(fileType),
            sort: [
                { [sortKey]: { order: sortOrd, unmapped_type: "keyword" } },
                { [getIdForSearchAfter(fileType)]: { order: ISortOrder.ASC } },
            ],
            query: composeQuery({
                area,
                filters: aFilters,
                filtersCondition,
            }),
            track_total_hits: true,
        };
    };
    const searchEsFolder = createSearchEs(FileType.FOLDER);
    const searchEsMedia = createSearchEs(FileType.MEDIA);
    const searchEsPortal = createSearchEs(FileType.PORTAL);
    const conf = {
        area,
        hrch,
        prnt,
        searchMode,
        searchEsFolder,
        searchEsMedia,
        searchEsPortal,
        searchScope: filtersScope,
    };
    const res = await getFiles(permissions, conf);
    if (isFiltered)
        return { ...res, folderPath: undefined };
    return res;
};
const searchEs = async ({ queryHistory, querySearch, permissions, sortKey, sortOrd, filters, filtersCondition, filtersScope, }) => {
    var _a, _b;
    const { area, hrch, prnt } = getQueryParams();
    const res = await searchFiles({
        permissions,
        sortKey,
        sortOrd,
        filters,
        filtersCondition,
        filtersScope,
        searchAfter: undefined,
        type: undefined,
        area,
        hrch,
        prnt,
    });
    const newQHrch = ((_a = res.folderData) === null || _a === void 0 ? void 0 : _a.hierarchyId) || "";
    const newQPrnt = ((_b = res.folderData) === null || _b === void 0 ? void 0 : _b.folderId) || 0;
    const newQueryPath = composePath(newQHrch, newQPrnt);
    if (!!newQueryPath && newQPrnt !== Number(prnt)) {
        updateSearchString({
            history: queryHistory,
            search: querySearch,
            path: newQueryPath,
        });
    }
    return res;
};
const useSearchEs = (a) => {
    const [searchTime, setSearchTime] = React.useState(null);
    const debounceSearchDocs = useConstant(() => AwesomeDebouncePromise(searchEs, 300));
    const searchRes = useAsyncAbortable(async (abortSignal, argDocs) => {
        //if (!a.area) return SEARCH_FILES_RESULT_DEFAULT;
        if (argDocs === null)
            return SEARCH_FILES_RESULT_DEFAULT;
        return debounceSearchDocs(a);
    }, [searchTime]);
    return {
        searchTime,
        setSearchTime,
        searchRes,
    };
};
export default useSearchEs;
